// ref: https://stackoverflow.com/a/34641566
export const requestWithNewUrl = async (request: Request, newUrl: string): Promise<Request> => {
  // Use arrayBuffer(), NOT blob(): a Blob body makes undici stream it via blob.stream(), minting a
  // native BlobReader that stays alive in Node's BaseObjectList, captures the request's
  // AsyncContextFrame, and pins the whole per-request SSR render graph -> ~4GB heap leak / OOM under
  // sustained traffic. An ArrayBuffer body uses a Uint8Array source with no BlobReader. See
  // docs/matrix-ssr-leak-findings-2026-06-23.md.
  const bodyPromise = request.headers.get('Content-Type')
    ? request.arrayBuffer()
    : Promise.resolve(undefined);

  return new Request(newUrl, {
    method: request.method,
    headers: request.headers,
    body: await bodyPromise,
    referrer: request.referrer,
    referrerPolicy: request.referrerPolicy,
    mode: request.mode,
    credentials: request.credentials,
    cache: request.cache,
    redirect: request.redirect,
    integrity: request.integrity,
  });
};
